import { render } from "./UserDetails.vue?vue&type=template&id=e606b616"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__